export default __webpack_public_path__ + "static/media/prepared.7707c051.svg";